import { render, staticRenderFns } from "./CampaignsMsgManagerView.vue?vue&type=template&id=6fa6c4b6&"
import script from "./CampaignsMsgManagerView.vue?vue&type=script&lang=js&"
export * from "./CampaignsMsgManagerView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports